module.exports = __webpack_public_path__ + "static/report-20975ab8adf8932fd41328d81c386ba3.png";